<div class="login">
    <span class="badge {{ wifi }}">
        <i class="fa fa-wifi" *ngIf="isConnected"></i>
        <i class="fa fa-exclamation-triangle" *ngIf="!isConnected"></i>
        {{ status }}</span>
    <img src="assets/logoDelphus.jpeg" width="280">
    <h5 class="mt-0">Iniciar sesión</h5>
    <div class="row">
        <div class="input-field col s12">
            <input id="usuario" name="usuario" type="text" #usuario class="validate">
            <label for="usuario">Usuario</label>
        </div>
        <div class="input-field col s12 my-0">
            <input id="contrasena" name="contrasena" type="password" #contrasena class="validate">
            <label for="contrasena">Contraseña</label>
        </div>
        <div class="mb-2">
            <label class="white-text">
                <input type="checkbox" [(ngModel)]="isChecked" (change)="checkValue()"/>
                <span>Botón Agregar Aves</span>
            </label>
        </div>
        <div class="col s12">
            <button class="btn waves-effect waves-light btn-large" type="button" (click)="login()">Iniciar sesión</button>
        </div>
    </div>
    <div>
        <img src="assets/logo-supergen.png" width="100">
    </div>
    <p class="my-0">FE: {{versionFE}} - BE: {{versionBE}}</p>
    <p class="my-0">Platform: {{platform}}</p>
    <!-- Modal Structure -->
    <div id="modal_login" class="modal">
        <div class="modal-content" style="background-color: #c51b1b;">
            <h4 class="white-text">{{ alert_message }}</h4>
        </div>
    </div>
</div>
